var _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLastPositionContraste(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    className: "seg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.125,
    height: 28.125,
    rx: 14.0625,
    fill: "",
    className: "fill"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 18,
    height: 18,
    fill: "url(#patternLastPositionContraste)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "patternLastPositionContraste",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_12_2",
    transform: "scale(0.0555556)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_12_2",
    width: 18,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAAFzUkdCAK7OHOkAAAAEZ0FNQQAAsY8L/GEFAAAACXBIWXMAAA7CAAAOwgEVKEqAAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAalJREFUOE+VlDtLA1EQhfeuTyK+GrGQNGqjjWBjpyAiWFilSOs/UBAhrQQt1ChCFNvoL7CwMUUKrQT/gY0i2PgCH0iyN35zdxJMTIw5cHbunDtn7oPd9ZqFtXYUbsCvIiBu61RjUN+JIQ4vxSywQXACD3Wc0tLawDgMk/BRDfeME3BISzy0A5nTtBIUzsNTKRAwPoeLDFu0pAz0DM2+NHXCgC0UVhBvnDkI3tFScExLfsF5rA3gppy/DVNazALEa7gEu7W+Llg4obaonPFIRhgzcEprGgJLC94HeFUS5Bh7LmkCLLqgG4g5oRgELzTKog3C3ir2wVZXWAX0HL5nYrsTbD4fI6kJVvug+ILY4YoV9vNzROeTKnlGHgjThFmW6ST+fCfmPGMmjDH98FU1qd8lX6ZX1Pf9O5Xrg92s68o9KsmRIuRv8EwlB19jPUQ0lkGjGLvpYrgVKiEaNfqNYnGNLd4a38+p4tCoUWk+kAe7maTBOPe2w+VWfF9/NzKmEAbjTDRalQsjP5b838A4A8Wb5eL3dZzW6ebA9xSnyZM2kV9G+AJWwPO+AUzCpWVIY/byAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastPositionContraste);
export default __webpack_public_path__ + "static/media/LastPositionContraste.025b139b.svg";
export { ForwardRef as ReactComponent };